import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

import { IRemoteSelectFieldCustomData } from "@/components/ui/autoform/components/custom/RemoteSelectField";
import { geodataEditSchema } from "@/pages/geodata/schemas/geodata.edit.form";

/**
 * The geodata copy an event or venue carries. `enrichmentStatus` rides along:
 * the owning entity's update writes `geodata` whole, and the edit schema below
 * leaves the lifecycle field out on purpose (a curator must not set it on the
 * geodata page) — so without it here every event save reset the copy to
 * `Unavailable`. It is never drawn: the remoteSelect renders the pick, not its keys.
 */
export const geodataNestedFormSchema = geodataEditSchema
  .extend({ enrichmentStatus: z.string().nullish() })
  .superRefine(
    fieldConfig({
      fieldType: "remoteSelect",
      customData: {
        getListParams: (query) => ({
          resource: "geodata",
          pagination: {
            currentPage: 0,
            pageSize: 10,
          },
          filters: [
            {
              field: "name",
              operator: "contains",
              value: query,
            },
          ],
        }),
        accessorFn: (option: any) => ({
          id: option.id.toString(),
          name: `${option.name} (${option.countryCode})`,
        }),
      } as IRemoteSelectFieldCustomData,
    }),
  );
